import React, { useEffect, useRef, useState } from "react";
import startVideoBackground from "../../../assets/video/bg-landingpage.mov";
import fxmlogo from "../../../assets/icons/fxmedia-logo.png";
import bgFooter from "../../../assets/images/bg-footer.png";
import SelectTopic from "../../../component/menu/selectTopic";

export default function StartPage() {
  const videoRef = useRef(null);
  const [showTopic, setShowTopic] = useState(false);

  const handleSelectMenu = () => {
    setShowTopic((prevShowTopic) => !prevShowTopic);
  };

  useEffect(() => {
    sessionStorage.clear();
    sessionStorage.setItem("language", "EN");
  }, []);

  useEffect(() => {
    const videoElement = videoRef.current;
    const playVideo = () => {
      videoElement?.play().catch((error) => {
        console.error("Error trying to play video:", error);
      });
    };

    if (videoElement) {
      videoElement.addEventListener("loadeddata", playVideo);
    }

    return () => {
      if (videoElement) {
        videoElement.removeEventListener("loadeddata", playVideo);
      }
    };
  }, []);

  useEffect(() => {
    const currentAvatar = sessionStorage.getItem("avatar");
    if (!currentAvatar) {
      sessionStorage.removeItem("config_id");
      sessionStorage.removeItem("passphrase");
      sessionStorage.removeItem("topic");
      sessionStorage.removeItem("language");
      sessionStorage.removeItem("avatar");
      sessionStorage.removeItem("appId");
    }
  }, []);

  useEffect(() => {
    const adjustVideoPosition = () => {
      if (window.innerWidth >= 520) {
        if (videoRef.current) {
          videoRef.current.style.position = "relative";
          videoRef.current.style.top = "20px";
        }
      } else {
        if (videoRef.current) {
          videoRef.current.style.position = "static";
          videoRef.current.style.top = "0";
        }
      }
    };

    adjustVideoPosition();
    window.addEventListener("resize", adjustVideoPosition);

    return () => {
      window.removeEventListener("resize", adjustVideoPosition);
    };
  }, []);

  return (
    <div className="startpage">
      <div className="startpage__header">
        <img className="logo" src={fxmlogo} alt="FXMedia Logo" />
      </div>
      <video
        className="background-video"
        autoPlay
        loop
        muted
        playsInline
        preload="auto"
        ref={videoRef}
        src={startVideoBackground}
        type="video/mp4"
        style={{ objectFit: "cover" }}
      ></video>
      <div className="startpage__content">
        <div className="startpage__start-button" onClick={handleSelectMenu}>
          <p>start now</p>
        </div>
        <img src={bgFooter} alt="" />
      </div>

      {showTopic && <SelectTopic handleSelectMenu={handleSelectMenu} />}
    </div>
  );
}
